import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputModal from "../../Component/Common/ConstomModal/InputModal";
import { InputField } from "../../Component/Common/InputField";
import { checkFormError } from "../../helper";
import { modalInputSchema } from "../../helper/errorSchema";
import { setStorage } from "../../helper/storage";
import UserContext from "../../helper/UserContext";

// The "Change App Name" modal from the old SortVoter.js, moved to its own
// routed page. This has no API call - it only writes the display app name
// to localStorage + UserContext, same as before.
export const ChangeAppName = () => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [inputValue, setInputValue] = useState({ name: "" });
  const [inputError, setInputError] = useState({ name: "" });
  const [isLoadding, setIsLoadding] = useState(false);

  const goBackToList = () => navigate("/application-management/list");

  const onSubmit = async () => {
    const validationResult = await checkFormError({ name: inputValue.name }, modalInputSchema);
    if (validationResult === true) {
      setIsLoadding(true);
      setStorage("app_name", inputValue.name);
      setUser({ ...user, appName: inputValue.name });
      setIsLoadding(false);
      goBackToList();
    } else {
      setInputError(validationResult);
      setIsLoadding(false);
    }
  };

  return (
    <InputModal
      isOpen
      headerName="App Name"
      toggle={goBackToList}
      submitLabel="Continue"
      onSubmit={onSubmit}
      disabled={!inputValue.name}
      isLoadding={isLoadding}
      inputProps={
        <InputField
          floating
          className="modal_input"
          label="App Name"
          labelClass="modal_label"
          labelSpan="*"
          labelSpanClass="style_for_star"
          placeholder="App Name"
          name="name"
          focus={!!inputError.name}
          error={inputError.name}
          value={inputValue.name}
          onChange={({ target: { name, value } }) => setInputValue({ ...inputValue, [name]: value })}
        />
      }
    />
  );
};
